module.exports = __webpack_public_path__ + "static/img/06.63d961f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotkeSlider/06.jpg
// module id = x6oq
// module chunks = 0